// extracted by mini-css-extract-plugin
module.exports = {"header":"header_AsF4f","title":"title_gX5hQ","actions":"actions_w57G8"};